import type { MonitoringSite } from '../../../../../types/apiModels'
import { apiClient } from '../../../client'
import endpoints from '../../../endpoints'
import { unwrapSingle } from '../../../normalize'

export default async function rename({
  siteId,
  name,
  signal,
}: {
  siteId: string
  name: string
  signal?: AbortSignal
}): Promise<MonitoringSite> {
  const response = await apiClient.patch(
    endpoints.v2.monitoring.siteName(siteId),
    { name },
    { signal },
  )
  return unwrapSingle<MonitoringSite>(response)
}
